import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "rounded-md border px-1.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none w-fit",
  {
    variants: {
      variant: {
        default:
          "border-transparent text-center bg-primary text-primary-foreground",
        secondary:
          "border-transparent bg-[#3E4352] text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
